export default __webpack_public_path__ + "static/media/Hvordan påvirker studententreprenørskap studenten.d1c90ace.pdf";